import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../login/AuthContext';
function ContactNowButton({ targetUserId, targetShowName,prefillMessage,t  }) {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
   console.log('targetUserId, targetShowName ',targetUserId, targetShowName )
  const handleContactNow = async () => {
    try {
      navigate(`/messages/${targetUserId}`, {
        state: { prefillMessage },  // Pass data here
      });
    } catch (error) {
      console.error("Error initiating conversation:", error);
    }
  };

  return (
    <p onClick={()=>handleContactNow()} className='btn btn-secondary'>
      💬 {t("Contact")}
    </p>
  );
}

export default ContactNowButton;
